import PropTypes from 'prop-types';
import { Step, StepLabel, Stepper } from '@mui/material';

// Barra de seguimiento de un pedido u orden de servicio: los pasos hasta `activeIndex` (el estado
// actual, incluido) salen completados y el actual ademas resaltado; los siguientes, en gris.
// Con `activeIndex` = -1 no hay ninguno completado.
export default function StatusProgress({ steps, activeIndex }) {
  return (
    <Stepper alternativeLabel sx={{ '& .MuiStepLabel-label': { fontSize: 12 } }}>
      {steps.map((step, index) => (
        <Step key={step.key} completed={index <= activeIndex} active={index === activeIndex}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

StatusProgress.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, label: PropTypes.string })).isRequired,
  activeIndex: PropTypes.number.isRequired,
};
